import PropTypes from "prop-types";

export default {
	duration: PropTypes.number,
	isOpen: PropTypes.bool,
	onFinished: PropTypes.func,
};
